var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCompanyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1594_62)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1239 0.901367C19.6234 0.901367 19.1902 1.07463 18.8245 1.42115L17.4095 2.83613L21.1635 6.59014L22.5784 5.17516C22.9249 4.80939 23.0983 4.37624 23.0983 3.8757C23.0983 3.37516 22.9249 2.94201 22.5784 2.57623L21.4233 1.42115C21.0576 1.07463 20.6245 0.901367 20.1239 0.901367ZM15.7089 12.0447L20.5282 7.22543L16.7742 3.47142L14.1465 6.11041C14.5763 6.13748 14.9425 6.29208 15.2452 6.57421C15.5322 6.88444 15.6868 7.26114 15.7089 7.70432V12.0447Z",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.147 6.11092C14.138 6.11035 14.1289 6.10983 14.1198 6.10938H4.05227C3.14707 6.13153 2.39642 6.44176 1.80032 7.04006C1.20422 7.63835 0.895125 8.39176 0.873047 9.30028V19.9366C0.895125 20.8452 1.20422 21.5986 1.80032 22.1969C2.39642 22.7952 3.14707 23.1054 4.05227 23.1276H14.6497C14.9588 23.1276 15.2126 23.0278 15.4114 22.8284C15.61 22.629 15.7094 22.3852 15.7094 22.0971C15.6873 21.6983 15.5107 21.3991 15.1795 21.1997V18.4741C15.5107 18.1639 15.6873 17.765 15.7094 17.2776V12.0452L13.8004 13.9542C13.4924 14.2623 13.1266 14.4837 12.7031 14.6185L9.23783 15.6292C8.96831 15.7062 8.73729 15.6388 8.54478 15.427C8.35227 15.2537 8.29451 15.0323 8.37152 14.7628L9.38221 11.2976C9.51697 10.8741 9.73837 10.5179 10.0464 10.2292L14.147 6.11092ZM4.05227 21.0003H13.5899V18.873H4.05227C3.74318 18.873 3.48928 18.9727 3.29058 19.1721C3.09188 19.3716 2.99253 19.6264 2.99253 19.9366C2.99253 20.2469 3.09188 20.5017 3.29058 20.7011C3.48928 20.9006 3.74318 21.0003 4.05227 21.0003Z",
    fill: "#3CDBC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1594_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCompanyInfo);
export default __webpack_public_path__ + "static/media/icons_company_info.dfd323e2.svg";
export { ForwardRef as ReactComponent };